import React from "react";
import { Radio } from "@fluentui/react-components";
import styles from "./ResourceStyles.module.scss";

const SavedShift = (props) => {
  const { item, onChange } = props;
  console.log(item.id);
  return (
    <div className="col-6">
      <div className={styles.shiftItemWrap}>
        <Radio
          className="radioWrapper"
          value={item.id}
          onChange={onChange}
          label={
            <div className="d-flex align-items-center">
              <span className="text-md-500 subHeading-color">{item.name}</span>
              <div className="ms-6 text-sm-400 subHeading-color">
                <span className="me-6">{item.startTime}</span>
                to
                <span className="ms-6">{item.endTime}</span>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default SavedShift;
